import React, { Component } from "react";
import { Box, Breadcrumbs, Grid, Tab, Tabs, Typography } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import Link from "@mui/material/Link";

import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import CtDtp from "./CustomTool/CtDtp";
import CtTxt from "./CustomTool/CtTxt";
import TableList from "./CustomTool/TableList";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";

import { withRouter } from "../HOC/withRouter";
import HoCtToastContainer from "../HOC/HoCtToastContainer";

import "./AMCLiftInfo.css";
import {
  get_30DaysBack_FromCurrentDate,
  get_YMD_from_SYS,
  validatedate_min_max,
} from "../SystemUtility/SystemUtility";

/* ===================== CLASS COMPONENT ===================== */
class AMCLiftInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabValue: 1,
      ARD: null,
      isImportContactsOpen: false,
      formData: {
        fromDate: get_30DaysBack_FromCurrentDate(new Date()),
        toDate: get_YMD_from_SYS(new Date()),
        yearlytotalservice: "",
        PaymentType: "",
        year: "",
        month: "",
        heightOfLift: "",
        usageOfLift: "",
        liftLicense: "",
        licenseExp: "",
        liftName: "Lift A",
        liftCode: "BVN11060004",
        contracttype: "Popular",
        documentNo: "TOP/AMC/BVN/25-26/03",
      },

      paymentRows: [
        {
          ID: 1,
          periodFromDate: "",
          periodToDate: "",
          amount: "50000",
        },
        {
          ID: 2,
          periodFromDate: "",
          periodToDate: "",
          amount: "50000",
        },
      ],

      contactRows: [
        { ID: 1, name: "", designation: "", mobile: "", email: "" },
        { ID: 2, name: "", designation: "", mobile: "", email: "" },
      ],
      importContactRows: [
        {
          ID: 1,
          selected: false,
          name: "Raj",
          designation: "Chairman",
          mobile: "1234567890",
          email: "raj@gmail.com",
        },
        {
          ID: 2,
          selected: false,
          name: "Suresh",
          designation: "Secretary",
          mobile: "6564567890",
          email: "",
        },
        {
          ID: 3,
          selected: false,
          name: "Amit",
          designation: "Treasurer",
          mobile: "7654567890",
          email: "amit@gmail.com",
        },
        {
          ID: 4,
          selected: false,
          name: "Vijay",
          designation: "Vice Chairman",
          mobile: "8734567890",
          email: "",
        },
      ],
      importColumns: [
        {
          id: "selected",
          label: "",
          type: "Chk",
          CtrlProps: { label: "" },
          headertype: "Chk",
          headerCtrlProps: { label: "", value: false },
        },
        { id: "name", label: "Name" },
        { id: "designation", label: "Designation" },
        { id: "mobile", label: "Mobile No" },
        { id: "email", label: "Email Id" },
      ],
    };
  }

  componentDidMount() {
    document.title = "Top India Elevator : AMC Lift Info";
    const firstCtrl = document.getElementById("fromDate");
    if (firstCtrl) {
      firstCtrl.focus();
    }
  }

  /* ===================== TAB CHANGE ===================== */
  handleTabChange = (_, newValue) => {
    this.setState({ tabValue: newValue });

    if (newValue === 0) {
      // Goes to /AMCSiteInfo
      this.props.navigateTo("AMCSiteInfo");
    }
  };

  handleOnChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: value,
      },
    }));
  };

  /* ===================== PAYMENT TABLE ===================== */
  handlePaymentAddRow = () => {
    this.setState((prevState) => ({
      paymentRows: [
        ...prevState.paymentRows,
        {
          ID: Date.now(),
          periodFromDate: "",
          periodToDate: "",
          amount: "",
        },
      ],
    }));
  };

  handlePaymentActionClick = (rowData) => {
    if (rowData.actionName === "Delete") {
      this.setState((prevState) => ({
        paymentRows: prevState.paymentRows.filter(
          (row) => row.ID !== rowData.ID,
        ),
      }));
    }
  };

  /* ===================== CONTACT TABLE ===================== */
  handleContactAddRow = () => {
    this.setState((prevState) => ({
      contactRows: [
        ...prevState.contactRows,
        {
          ID: Date.now(),
          name: "",
          designation: "",
          mobile: "",
          email: "",
        },
      ],
    }));
  };

  handleContactActionClick = (rowData) => {
    if (rowData.actionName === "Delete") {
      this.setState((prevState) => ({
        contactRows: prevState.contactRows.filter(
          (row) => row.ID !== rowData.ID,
        ),
      }));
    }
  };

  handleImportContactRowChange = (rows) => {
    const allSelected =
      rows.length > 0 && rows.every((row) => row.selected === true);
    const importColumns = this.state.importColumns.map((col) => {
      if (col.id === "selected") {
        return {
          ...col,
          headerCtrlProps: {
            ...col.headerCtrlProps,
            value: allSelected,
          },
        };
      }
      return col;
    });
    this.setState({ importContactRows: rows, importColumns });
  };

  handleImportContactColumnChange = (columns) => {
    this.setState({ importColumns: columns });
  };

  handleSelectAllContacts = () => {
    this.setState((prevState) => ({
      importContactRows: prevState.importContactRows.map((row) => ({
        ...row,
        selected: true,
      })),
    }));
  };

  handleDeselectAllContacts = () => {
    this.setState((prevState) => ({
      importContactRows: prevState.importContactRows.map((row) => ({
        ...row,
        selected: false,
      })),
    }));
  };

  handleImportContacts = () => {
    const selectedRows = this.state.importContactRows.filter(
      (row) => row.selected === true,
    );
    this.setState({
      contactRows: selectedRows.map((row) => ({
        ID: row.ID,
        name: row.name,
        designation: row.designation,
        mobile: row.mobile,
        email: row.email,
      })),
      ARD: null,
      isImportContactsOpen: false,
    });
    return true;
  };

  openImportContactsDialog = () => {
    this.setState({ isImportContactsOpen: true });
  };

  renderImportContactsDialog = () => {
    return (
      <Grid sx={{ padding: "6px 8px" }}>
        <TableList
          columns={this.state.importColumns}
          rows={this.state.importContactRows}
          rowsCount={this.state.importContactRows.length}
          rowsPerPage={25}
          handleOnRowDataChange={this.handleImportContactRowChange}
          handleOnColumnChange={this.handleImportContactColumnChange}
          noMobileLayout
        />
      </Grid>
    );
  };

  openJsdInfoDialog = () => {
    const ARD = (
      <AlertResponsiveDialog
        alertMessage={this.renderJsdInfoDialog()}
        defaultOpenDialog={true}
        handleOnClickNo={() => this.setState({ ARD: null })}
      />
    );
    this.setState({ ARD });
  };

  renderJsdInfoDialog = () => {
    return (
      <Grid sx={{ padding: "8px 12px", minWidth: 360 }}>
        <Typography fontSize={18} fontWeight={600} textAlign="center">
          JSD INFO
        </Typography>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 4,
            marginTop: 1.5,
            marginBottom: 1,
          }}
        >
          <CtBtn
            label="JSD NEW ENTRY"
            firstletterBig={false}
            className="secondary-button"
            width={150}
            size="small"
          />
          <CtBtn
            label="IMPORT JSD"
            firstletterBig={false}
            className="secondary-button"
            width={120}
            size="small"
          />
        </Grid>
        <Grid sx={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            type="button"
            className="amc-import-close-link"
            onClick={() => this.setState({ ARD: null })}
          >
            CLOSE
          </button>
        </Grid>
      </Grid>
    );
  };

  clearInfo = () => {
    this.setState(
      {
        formData: {
          fromDate: get_30DaysBack_FromCurrentDate(new Date()),
          toDate: get_YMD_from_SYS(new Date()),
          yearlytotalservice: "",
          PaymentType: "",
          year: "",
          month: "",
          heightOfLift: "",
          usageOfLift: "",
          liftLicense: "",
          licenseExp: "",
          liftName: "Lift A",
          liftCode: "BVN11060004",
          contracttype: "Popular",
          documentNo: "TOP/AMC/BVN/25-26/03",
        },
        paymentRows: [],
        contactRows: [],
      },
      () => {
        document.getElementById("fromDate");
      },
    );
  };

  validationLiftInfo = () => {
    let result = false;
    const { formData } = this.state;
    if (this.state.formData.fromDate.length <= 0) {
      this.props.toastErrorMsg("Select From Date", "fromDate");
    } else if (this.state.formData.toDate.length <= 0) {
      this.props.toastErrorMsg("Select To Date", "toDate");
    } else if (
      !formData.yearlytotalservice ||
      formData.yearlytotalservice.length <= 0
    ) {
      this.props.toastErrorMsg(
        "Enter Yearly Total Service",
        "yearlytotalservice",
      );
    } else if (!formData.PaymentType || formData.PaymentType.length <= 0) {
      this.props.toastErrorMsg("Select Payment Type", "PaymentType");
    } else if (!formData.year || formData.year.length <= 0) {
      this.props.toastErrorMsg("Enter Year", "year");
    } else if (!formData.month || formData.month.length <= 0) {
      this.props.toastErrorMsg("Enter Month", "month");
    } else if (!formData.liftLicense || formData.liftLicense.length <= 0) {
      this.props.toastErrorMsg("Enter Lift License No", "liftLicense");
    } else if (!formData.licenseExp || formData.licenseExp.length <= 0) {
      this.props.toastErrorMsg("Select License Expiry Date", "licenseExp");
    } else {
      result = true;
    }

    return result;
  };

  saveLiftInfo = () => {
    if (this.validationLiftInfo()) {
      this.props.toastMsg("success", "AMC Lift Info Save Successfully");
      this.clearInfo();
    }
  };

  DeleteData = (documentNo) => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelAgree="Delete"
          labelDisagree="Cancel"
          alertTitle={`Do you want to delete Document No : ${documentNo} ?`}
          alertMessage=""
          handleOnClickYes={() => {
            return this.DeleteLiftInfo(documentNo);
          }}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
    return false;
  };

  DeleteLiftInfo = (documentNo) => {
    this.props.toastMsg("success", "AMC Lift Info Delete Successfully");
    this.clearInfo();
  };

  /* ===================== RENDER ===================== */
  render() {
    const { tabValue, paymentRows, contactRows, formData, ARD } = this.state;

    const paymentColumns = [
      { id: "action", label: "", width: 0 },
      {
        id: "periodFromDate",
        label: "Period From Date",
        type: "CtDtp",
        CtrlProps: { width: 130 },
      },
      {
        id: "periodToDate",
        label: "Period To Date",
        type: "CtDtp",
        CtrlProps: { width: 130 },
      },
      {
        id: "amount",
        label: "Amount",
        type: "CtTxtAmt",
        CtrlProps: { width: 120, maxLength: 10 },
      },
    ];

    const contactColumns = [
      { id: "action", label: "", width: 30 },
      {
        id: "name",
        label: "Name",
        type: "CtTxt",
        CtrlProps: { width: 120, maxLength: 100 },
      },
      {
        id: "designation",
        label: "Designation",
        type: "CtTxt",
        CtrlProps: { width: 140, maxLength: 100 },
      },
      {
        id: "mobile",
        label: "Mobile No",
        type: "CtTxt",
        CtrlProps: { width: 120, maxLength: 15 },
      },
      {
        id: "email",
        label: "Email Id",
        type: "CtTxt",
        CtrlProps: { width: 160, maxLength: 100 },
      },
    ];

    return (
      <Grid className="amc-liftinfo-page">
        <Typography fontSize={30} fontWeight={600} marginBottom={2}>
          AMC Details
        </Typography>

        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/#/Dashboard">
            Dashboard
          </Link>
          <Link underline="hover" color="inherit" href="/#/AMCDashboard">
            AMC Dashboard
          </Link>
          <Link underline="hover" color="inherit" href="/#/AMCList">
            AMC List
          </Link>
          <Link underline="hover" color="inherit" href="/#/AMCRegistration">
            AMC Registration
          </Link>
          <Typography sx={{ color: "text.primary" }}>Lift A</Typography>
        </Breadcrumbs>

        <Grid className="amc-liftinfo-tabs">
          <Tabs value={tabValue} onChange={this.handleTabChange}>
            <Tab label="Site Info" />
            <Tab label="Lift Info" />
          </Tabs>
        </Grid>

        <Grid className="amc-liftinfo-panel">
          {/* HEADER */}
          <Grid className="amc-liftinfo-header">
            <Grid className="amc-liftinfo-summary">
              <Grid>
                <Typography className="amc-liftinfo-label">
                  Lift Name
                </Typography>
                <Typography className="amc-liftinfo-value">
                  {formData.liftName}
                </Typography>
              </Grid>

              <Grid>
                <Typography className="amc-liftinfo-label">
                  Lift Code
                </Typography>
                <Typography className="amc-liftinfo-value">
                  {formData.liftCode}
                </Typography>
              </Grid>

              <Grid>
                <Typography className="amc-liftinfo-label">
                  Contract Type
                </Typography>
                <Typography className="amc-liftinfo-value">
                  {formData.contracttype}
                </Typography>
              </Grid>

              <Grid>
                <Typography className="amc-liftinfo-label">
                  Document No
                </Typography>
                <Typography className="amc-liftinfo-value">
                  {formData.documentNo}
                </Typography>
              </Grid>
            </Grid>

            <Grid className="amc-liftinfo-header-actions">
              <CtBtn
                label="SAVE"
                iconName="save"
                firstletterBig={false}
                onClick={this.saveLiftInfo}
              />
              {/* <CtBtn
                label="DELETE"
                iconName="delete"
                firstletterBig={false}
                className="delete-button"
                onClick={this.DeleteData}
              /> */}
              <CtBtn
                label="DELETE"
                iconName="delete"
                firstletterBig={false}
                className="delete-button"
                onClick={() => this.DeleteData(this.state.formData.documentNo)}
              />

              <Grid className="amc-liftinfo-status">AMC Active</Grid>
            </Grid>
          </Grid>

          {/* FORM */}
          <Grid container spacing={2} marginTop={2}>
            <Grid item>
              <CtDtp
                id="fromDate"
                label="From Date*"
                width={140}
                value={formData.fromDate}
                handleOnChange={this.handleOnChange}
                nextCtrlID={"toDate"}
                onKeyDown={this.props.onKeyDown}
              />
            </Grid>
            <Grid item>
              <CtDtp
                id="toDate"
                label="To Date*"
                width={140}
                value={formData.toDate}
                handleOnChange={this.handleOnChange}
                nextCtrlID={"yearlytotalservice"}
                onKeyDown={this.props.onKeyDown}
              />
            </Grid>
            <Grid item>
              <CtTxt
                id="yearlytotalservice"
                name="yearlytotalservice"
                label="Yearly Total Service*"
                width={160}
                value={formData.yearlytotalservice || ""}
                handleOnChange={this.handleOnChange}
                nextCtrlID={"PaymentType"}
                onKeyDown={this.props.onKeyDown}
              />
            </Grid>
            <Grid item>
              <CtCmb
                id="PaymentType"
                name="PaymentType"
                label="Payment Type*"
                items={["Advance", "After Service"]}
                width={140}
                value={formData.PaymentType || ""}
                handleOnChange={this.handleOnChange}
                nextCtrlID={"year"}
                onKeyDown={this.props.onKeyDown}
              />
            </Grid>
            <Grid item>
              <CtTxt
                id="year"
                name="year"
                label="Year*"
                width={80}
                maxLength={4}
                value={formData.year || ""}
                handleOnChange={this.handleOnChange}
                nextCtrlID={"month"}
                onKeyDown={this.props.onKeyDown}
              />
            </Grid>
            <Grid item>
              <CtTxt
                id="month"
                name="month"
                label="Month*"
                width={80}
                maxLength={2}
                value={formData.month || ""}
                handleOnChange={this.handleOnChange}
              />
            </Grid>
          </Grid>

          {/* PAYMENT TABLE */}
          <Grid marginTop={2} marginBottom={2} className="amc-liftinfo-table">
            <TableList
              columns={paymentColumns}
              rows={paymentRows}
              rowsCount={paymentRows.length}
              rowsPerPage={25}
              handleOnRowDataChange={(rows) =>
                this.setState({ paymentRows: rows })
              }
              handleOnActionClick={this.handlePaymentActionClick}
              handleOnNewEntryClick={this.handlePaymentAddRow}
              actionList={[
                {
                  name: "Delete",
                  icon: <Delete style={{ color: "#e53935" }} />,
                },
              ]}
              noMobileLayout
            />
          </Grid>

          {/* HEIGHT / USAGE / LICENSE */}
          <Grid container spacing={2} marginTop={1} marginBottom={2}>
            <Grid item>
              <CtTxt
                id="heightOfLift"
                label="Height OF Lift"
                width={200}
                nextCtrlID={"usageOfLift"}
                onKeyDown={this.props.onKeyDown}
              />
            </Grid>
            <Grid item>
              <CtCmb
                id="usageOfLift"
                label="Usage Of Lift"
                items={[""]}
                width={200}
                nextCtrlID={"liftLicense"}
                onKeyDown={this.props.onKeyDown}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} marginBottom={2}>
            <Grid item>
              <CtTxt
                id="liftLicense"
                name="liftLicense"
                label="Lift License No.*"
                width={200}
                value={formData.liftLicense || ""}
                handleOnChange={this.handleOnChange}
                nextCtrlID={"licenseExp"}
                onKeyDown={this.props.onKeyDown}
              />
            </Grid>
            <Grid item>
              <CtDtp
                id="licenseExp"
                name="licenseExp"
                label="License Exp Dt.*"
                width={200}
                value={formData.licenseExp || ""}
                handleOnChange={this.handleOnChange}
              />
            </Grid>
          </Grid>

          {/* CONTACT TABLE */}
          <Grid className="amc-liftinfo-contact-header">
            <Typography fontWeight={500} fontSize={18}>
              Contact Person Details
            </Typography>
            <CtBtn
              label="Import Site Contacts"
              firstletterBig={false}
              className="child-button"
              variant="outlined"
              onClick={this.openImportContactsDialog}
            />
          </Grid>

          <Grid marginTop={1} marginBottom={2} className="amc-liftinfo-table">
            <TableList
              columns={contactColumns}
              rows={contactRows}
              rowsCount={contactRows.length}
              rowsPerPage={25}
              handleOnRowDataChange={(rows) =>
                this.setState({ contactRows: rows })
              }
              handleOnActionClick={this.handleContactActionClick}
              handleOnNewEntryClick={this.handleContactAddRow}
              actionList={[
                {
                  name: "Delete",
                  icon: <Delete style={{ color: "#e53935" }} />,
                },
              ]}
              noMobileLayout
            />
          </Grid>

          <Typography className="amc-liftinfo-subtitle">JSD Details</Typography>

          <CtBtn
            label="Go To The JSD Information"
            firstletterBig={false}
            className="child-button"
            variant="outlined"
            onClick={this.openJsdInfoDialog}
          />
        </Grid>
        {this.state.isImportContactsOpen && (
          <AlertResponsiveDialog
            labelAgree="IMPORT"
            labelDisagree="Close"
            alertMessage={this.renderImportContactsDialog()}
            actionAlign="center"
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
            handleOnClickYes={this.handleImportContacts}
            handleOnClickNo={() => this.setState({ isImportContactsOpen: false })}
          />
        )}
        {ARD}
      </Grid>
    );
  }
}

/* ===================== EXPORT ===================== */
export default HoCtToastContainer(withRouter(AMCLiftInfo));
